<template lang="pug">
  SspLayout.statistics(area="core")
    template(slot="actions")
        Datepicker(v-if="activeTab === 0" v-model="time.start" placeholder="Start Date")
        .ml15
        Datepicker(v-if="activeTab === 0" v-model="time.end" placeholder="End Date")
    .form-horizontal
      .row
        .sidebar.col-md-2
          ul.navigation
            li.navigation-items.clickable(v-for="(tab, index) in tabNavigation" :class="{active: activeTab === index}")
              a(@click="activeTab = index") {{tab.title}}
        .col-md-10(v-if="currentTabData")
          .text-center
            i.center-loader.fa.fa-spinner.fa-pulse.fa-spin.fa-4x(v-if="loading")
          component(:is="tabNavigation[activeTab].component" :data="currentTabData")

</template>

<script>
import Core from '@/service/apis/Core'
import Datepicker from '@/components/common/Datepicker'
import Overview from './Overview'
import LastOrders from './LastOrders'
import LastOrderExpansions from './LastOrderExpansions'

export default {
  data() {
    return {
      loading: false,
      time: this.initialTime(),
      currentTabData: null,
      activeTab: 0,
      tabNavigation: [{
        title: 'Overview',
        component: Overview,
      }, {
        title: 'Last Orders',
        component: LastOrders
      }, {
        title: 'Last Order Expansions',
        component: LastOrderExpansions
      }]
    }
  },
  created() {
    this.init()
  },
  methods: {
    initialTime() {
      return {
        start: null,
        end: null
      }
    },
    getOverviewStatistics() {
      const req = {}
      req.startTime = this.time.start ? this.time.start : null
      req.endTime = this.time.end ? this.time.end : null
      req.organizationId = null
      return Core.overviewStatistics(req)
        .then((resp) => resp.data.entry)
    },
    getLastOrderStatistics() {
      return Core.getLastOrdersStatistics()
        .then((resp) => resp.data.order)
    },
    getLastOrderExpansions() {
      return Core.getLastOrderExpansions()
        .then((resp) => resp.data.expansion)
    },
    init() {
      let promise
      this.loading = true
      if (this.activeTab === 0) {
        promise = this.getOverviewStatistics()
      } else {
        this.time = this.initialTime()
        if (this.activeTab === 1) {
          promise = this.getLastOrderStatistics()
        } else if (this.activeTab === 2) {
          promise = this.getLastOrderExpansions()
        }
      }
      promise
        .then((data) => {
          this.currentTabData = data
          this.loading = false
        })
    }
  },
  watch: {
    activeTab() {
      this.init()
    },
    time: {
      handler() {
        if (this.activeTab === 0) {
          this.init()
        }
      },
      deep: true
    }
  },
  components: {
    Overview,
    LastOrders,
    LastOrderExpansions,
    Datepicker
  }
}
</script>

<style lang="scss">
 .statistics {
    .center-loader {
      position: absolute;
      top: 30%;
      left: 50%;
      z-index: 1000;
    }
 }
</style>



// WEBPACK FOOTER //
// src/components/pages/core/statistic/Statistics.vue